/**
 * Which unit a stock-in row keeps when it is matched to an inventory item
 * (suggestion chip, typed exact name, or the automatic yellow → green upgrade).
 *
 * The unit is part of what the quantity MEANS. Replacing it without converting the
 * quantity silently rescales the stock: "Paneer 2 kg" matched to a gram-tracked
 * Paneer used to become "2 g" — the same number, a thousandth of the stock.
 *
 *   • Same family (kg/g/mg, L/ml): the bill's unit stays. The backend converts the
 *     quantity into the item's unit at save.
 *   • Different family (kg vs pcs, kg vs ml): the row takes the inventory unit. The
 *     backend refuses cross-family mixes outright, so the bill's unit could never save.
 *   • Blank row unit: filled from inventory.
 *   • No inventory unit: nothing to apply; the row is left as it is.
 */

import UnitMappingService from '../services/unitMappingService';

function unitAfterMatch(rowUnit, inventoryUnit) {
  const inv = UnitMappingService.normalizeUnitSymbol(inventoryUnit);
  if (!inv) return rowUnit || '';

  const row = UnitMappingService.normalizeUnitSymbol(rowUnit);
  if (!row) return inv;

  return UnitMappingService.baseUnitOf(row) === UnitMappingService.baseUnitOf(inv) ? row : inv;
}

export { unitAfterMatch };
